import { Apiservice } from '@api/service'
export default {
    namespaced: true,
    state: {
        isCache: false, //是否已缓存
        // androidUrl: "http://5218.pw/app.php/163",//android下载地址
        // IOSUrl: "http://5218.pw/app.php/163",//ios下载地址
        // onlineQQUrl: "http://wpa.qq.com/msgrd?v=3&uin=3373035937&site=qq&menu=yes",
        // qrcodeUrl: "",//二维码地址,用不上了
        // androidUrl: "",//android下载地址
        // IOSUrl: "",//ios下载地址
        onlineQQUrl: "", //在线客服
        webname: '',
        qq_kefu_url: '',//qq客服
        h5_download_app_reward_img_uri: '',  //app下载图
        app_address: '',   // app下载地址
        is_open_red_bag: '0',   // 红包开启关闭
        is_open_sign: '0',   // 签到开启关闭
        sysParam: {},
        showDownBar: true,  //是否显示下载APP
        showSignEntry: true,   //是否显示签到
        showRedbagEntry: false,   //是否显示红包
        lottery_type_show_style: 0,
        sys_captcha_type: '0',
        forumTabList: [
            {
                lotteryTypeCode: 'LHC',
                lotteryCode: 'HKLHC',
                lotteryName: '香港六合彩',
                lotteryThemeColor: "#1a825b",
                lotterySecondaryColor: "#f2fcf8",
            },
            {
                lotteryTypeCode: 'LHC',
                lotteryCode: 'AMLHC',
                lotteryName: '澳门六合彩',
                lotteryThemeColor: "#fb5430",
                lotterySecondaryColor: "#fff9f8"
            }
        ],
        forum_support_lottery: [],
    },
    mutations: {
        setisForumSupportLottery(state, data) {
            state.forum_support_lottery = data;
        },
        setIsCache(state, data) {
            state.isCache = data;
        },
        setWebname(state, data) {
            state.webname = data;
        },
        // qrcodeUrl(state, data) {
        //     state.qrcodeUrl = data;
        // },
        setapp_address(state, data) {
            state.app_address = data;
        },
        setlottery_type_show_style(state, data) {
            state.lottery_type_show_style = data;
        },
        setis_open_red_bag(state, data) {
            state.is_open_red_bag = data;
        },
        setis_open_sign(state, data) {
            state.is_open_sign = data;
        },
        onlineQQUrl(state, data) {
            state.onlineQQUrl = data;
        },
        setqq_kefu_url(state, data) {
            state.qq_kefu_url = data;
        },
        seth5_download_app_reward_img_uri(state, data) {
            state.h5_download_app_reward_img_uri = data;
        },
        setShowDownBar(state, data) {
            state.showDownBar = data;
        },
        setShowSignEntry(state, data) {
            state.showSignEntry = data;
        },
        setShowRedbagEntry(state, data) {
            state.showRedbagEntry = data;
        },
        setSysCaptchaType(state, data) {
            state.sys_captcha_type = data;
        },
    },
    actions: {
        getParameter(context) {
            return new Promise((resolve, reject) => {
                // if (!context.state.isCache) {
                // context.commit("setIsCache", true);
                Apiservice().then(res => {
                    if (res.code == '12200') {
                        if (res.data.is_open_red_bag == "1") {
                            context.commit("setShowRedbagEntry", true);
                        }
                        // context.commit("qrcodeUrl", res.data.app_qr_address);
                        context.commit("setapp_address", res.data.app_address_fixed);
                        context.commit("onlineQQUrl", res.data.official_kefu_url);
                        context.commit("setqq_kefu_url", res.data.qq_kefu_url);
                        context.commit("setWebname", res.data.web_name);
                        context.commit("seth5_download_app_reward_img_uri", res.data.h5_download_app_reward_img_uri);
                        context.commit("setis_open_red_bag", res.data.is_open_red_bag);
                        context.commit("setis_open_sign", res.data.is_open_sign);
                        context.commit("setlottery_type_show_style", Number(res.data.lottery_type_show_style));
                        context.commit("setSysCaptchaType", res.data.sys_captcha_type);
                        let forumLotterylist = ''
                        if (res.data.forum_support_lottery) {
                            forumLotterylist = JSON.parse(res.data.forum_support_lottery).filter((item) => {
                                return !item.isEnable || item.isEnable == '1'
                            })
                        }
                        if (forumLotterylist && forumLotterylist.length > 0) {
                            context.commit("setisForumSupportLottery", forumLotterylist);
                        } else {
                            context.commit("setisForumSupportLottery", context.state.forumTabList);
                        }

                        // context.commit("setSysCaptchaType", '0');
                        context.state.sysParam = res.data;
                        resolve(context.state.sysParam)
                    } else {
                        reject()
                    }
                }).catch((e) => {
                    console.warn(e)
                    reject()
                    context.commit("setIsCache", false);
                })
                // }
                // resolve(context.state.sysParam)
            })
        }
    }
}